var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack374({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.15,1.19.65,14.81h15ZM9,12.63a1.92,1.92,0,0,1-1,.25H6.51v-5H7.93a2.36,2.36,0,0,1,.8.1,1.32,1.32,0,0,1,.62.43,2.29,2.29,0,0,1,.41.81,3.84,3.84,0,0,1,.15,1.14,3.69,3.69,0,0,1-.25,1.45A1.84,1.84,0,0,1,9,12.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.61,8.55a2,2,0,0,0-.69-.09H7.06v3.82h.87a1.47,1.47,0,0,0,.8-.17,1,1,0,0,0,.42-.55,3.43,3.43,0,0,0,.2-1.22,2.81,2.81,0,0,0-.21-1.2A1.15,1.15,0,0,0,8.61,8.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack374);
export default __webpack_public_path__ + "static/media/Symbol_pack_374.bda427f3c8ef525e846da78d3ec0a52b.svg";
export { ForwardRef as ReactComponent };